import { QRCodeSVG } from "qrcode.react";
import { toPng } from "html-to-image";
import { useRef } from "react";

function QRCodeCard(props) {
    const Card = useRef(null);

    const origin = window.location.origin;
    const generalText = "Tilkall leksehjelp:";
    const location = [props.location[0], props.location[1]];
    const link = origin+"/elev/"+btoa(location[0])+"/"+btoa(location[1]);
    
    const downloadOnClick = () => {
        toPng(Card.current, {cacheBust: true})
            .then(dataURL => {
                const linkToImage = document.createElement("a");
                linkToImage.download = `${location[0]}-${location[1]}-QR-kode.png`;
                linkToImage.href = dataURL;
                linkToImage.click();
            });
    };

    return (
        <div className="QRCode-card-container-QROverview-page">
            <div ref={Card} className="QRCode-card-downloadable-QROverview-page">
                <h2>{generalText}</h2>
                <QRCodeSVG
                    value={link}
                    size={200}
                    bgColor="#ffffff"
                    fgColor="#000000"
                    level="H"
                />
                <p><b>Gjelder: </b>{location[0]} {location[1]}</p>
            </div>
            <button onClick={downloadOnClick}>Last ned</button>
        </div>
    );
};

export default QRCodeCard;